import { createSelector } from 'reselect'
import getCustomerProductLAS from './getCustomerProductLAS'
import getCustomerProduct from './getCustomerProduct'

export default function makeGetCustomerProductOrganisationalUnits() {
  return createSelector(
    [getCustomerProductLAS, getCustomerProduct],
    (las, customerProduct) => customerProduct?.metadata?.exporters?.[las]?.organisationalUnits,
  )
}
